import { Step } from './step';

export class CourseStepCertificate extends Step {}
